import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import {
    LayoutDashboard,
    Users as UsersIcon,
    Link as LinkIcon,
    Wallet,
    Settings,
    LogOut,
    Dumbbell,
} from 'lucide-react';

const navigation = [
    { name: 'Dashboard', href: '/admin', icon: LayoutDashboard },
    { name: 'Influencers', href: '/admin/influencers', icon: UsersIcon },
    { name: 'Códigos', href: '/admin/codes', icon: LinkIcon },
    { name: 'Comissões', href: '/admin/commissions', icon: Wallet },
    { name: 'Usuários', href: '/admin/users', icon: UsersIcon },
];

export function AdminLayout() {
    const { profile, signOut } = useAuth();
    const location = useLocation();

    return (
        <div className="min-h-screen bg-gray-100 dark:bg-gray-950">
            {/* Header */}
            <header className="bg-gray-900 text-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        <div className="flex items-center gap-8">
                            <Link to="/admin" className="flex items-center gap-3">
                                <img src="/gofit-logo.png" alt="GoFit" className="w-9 h-9" />
                                <span className="font-bold text-lg text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>
                                    GoFit Admin
                                </span>
                            </Link>

                            <nav className="hidden md:flex items-center gap-1">
                                {navigation.map((item) => {
                                    const isActive =
                                        item.href === '/admin'
                                            ? location.pathname === '/admin'
                                            : location.pathname.startsWith(item.href);
                                    const Icon = item.icon;

                                    return (
                                        <Link
                                            key={item.name}
                                            to={item.href}
                                            className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${isActive
                                                ? 'bg-gray-800 text-white'
                                                : 'text-gray-300 hover:text-white hover:bg-gray-800'
                                                }`}
                                        >
                                            <Icon className="w-4 h-4" />
                                            <span>{item.name}</span>
                                        </Link>
                                    );
                                })}
                            </nav>
                        </div>

                        <div className="flex items-center gap-4">
                            <span className="text-sm text-gray-300">
                                {profile?.full_name}
                            </span>
                            <button
                                onClick={async () => {
                                    await signOut();
                                    window.location.href = '/login';
                                }}
                                className="p-2 rounded-lg hover:bg-gray-800 text-gray-300 hover:text-white transition-colors"
                            >
                                <LogOut className="w-5 h-5" />
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            {/* Main content */}
            <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <Outlet />
            </main>
        </div>
    );
}
